module.exports = __webpack_public_path__ + "fonts/AftaSansThin-Regular.2565b94d.woff2";